import { Component, OnInit } from '@angular/core';
import { BaseListComponent } from '../../../../shared/base/base-list.component'
import { BooleanFields, RouteAuthorities, ValueLabel } from 'src/app/shared/base/base.models';
import { AuthService } from '../../../../core/auth.service';
import { LoadingService } from '../../../../core/loading.service';
import { DialogService } from '../../../../core/dialog.service';
import { AlertService } from '../../../../core/alert.service';
import { UtilityService } from '../../../../core/utility.service';
import { RequestService } from '../../../../core/request.service';
import { BaseService } from 'src/app/shared/base/base.service';
import { TranslateService } from '@ngx-translate/core';
import { Constants } from 'src/app/app.constants';
import { UsersService } from '../../users/users.service';
import { CustomersService } from '../../customers/customers.service';

@Component({
  selector: 'app-customers-list',
  templateUrl: './customers-list.component.html',
  styleUrls: ['./customers-list.component.scss']
})
export class CustomersListComponent extends BaseListComponent implements OnInit {
  public gridStateKey: string = 'customers_list_grid_state';
  public lookupColumns: Array<string> = ['name', 'login', 'email', 'userType','active'];

  // public userTypes: ValueLabel[] = [];
  // public rolesLookUp: Role[] = [];

  public keyRole: string ='CLIENT_CUSTOMER';
  public customerStatuses: ValueLabel[] = [];

  constructor(
    public customersService: CustomersService,
    public usersService: UsersService,
    public authService: AuthService,
    public loadingService: LoadingService,
    public baseService: BaseService,
    public dialogService: DialogService,
    public alertService: AlertService,
    public utilityService: UtilityService,
    public requestService: RequestService,
    public translateService: TranslateService
  ) {
    super(authService, loadingService, baseService, dialogService, alertService, utilityService, requestService, translateService);
    this.authorities = new RouteAuthorities(authService, alertService, 'C_USR', 'R_USR', 'U_USR', null);
    this.creatable = this.authorities.create;
    this.editable = this.authorities.update;
    this.deletable = this.authorities.delete;
    this.activatable = this.authorities.update;
  }

  ngOnInit(): void {
    this.url = `${Constants.contextPath}/users`;
    this.prepareLookupData();
    this.getGridData();
  }

  private prepareLookupData() {
    this.customerStatuses = this.utilityService.prepareLookupItems(this.utilityService.enumToSelectArray(BooleanFields, true), 'value', 'label', 'ENUMS.ACTIVE_FIELDS.');
  }

  public changeStatusForUser(id: string, active: boolean) {
    if(id != this.authService.userId) 
      this.changeStatus(id, active);
  }

  public loadGridState = (): any => {
    return this.loadGridStateBase(this.gridStateKey, this.lookupColumns);
  }

  public saveGridState = (state: any): void => {
    this.saveGridStateBase(state, this.gridStateKey, this.lookupColumns);
  }

  public getGridData() {    
    this.dataSource = this.customersService.getUsersByRole(this.keyRole).store;
  }
}
